import {
  Button,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  DialogTitle
} from "@mui/material";
import Field from "components/Field";
import { pick } from "lodash";
import { useMemo } from "react";
import { Form } from "react-final-form";
import { useIntl } from "react-intl";
import { Webinar } from "services/KnowfullyAdminClient";
import { CommonFormProps } from "types/common-types";

type UpdateDeliveryKeyFormProps = CommonFormProps<Webinar, string>;

const UpdateDeliveryKeyForm = ({
  entity: webinar,
  onCancel,
  onSubmit,
}: UpdateDeliveryKeyFormProps) => {
  const { formatMessage: t } = useIntl();

  const init = useMemo(
    () => ({
      ...pick(webinar ?? {}, ["id", "skuDeliveryMethodKey"]),
    }),
    [webinar]
  );

  return useMemo(() => {
    return (
      <Form
        onSubmit={onSubmit}
        initialValues={init}
        render={({ handleSubmit, submitting, pristine }) => (
          <form onSubmit={handleSubmit} noValidate>
            <DialogTitle>{t({ id: "editDeliveryMethodKeyLabel" })}</DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={1}>
                <Field name="skuDeliveryMethodKey" required>
                  {({ input, meta }) => (
                    <Grid item xs={12}>
                      <TextField variant="standard"
                        fullWidth
                        required
                        label={t({ id: "contentDeliveryKey" })}                        
                        error={meta.error && meta.submitFailed}
                        helperText={
                          meta.error && meta.submitFailed && meta.error
                        }
                        {...input}
                        data-cy="skuFormDeliveryMethodKeyText"
                      />
                    </Grid>
                  )}
                </Field>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button disabled={submitting} onClick={onCancel} data-cy="cancelButton">
                {t({ id: "cancelButton" })}
              </Button>

              <Button type="submit" color="primary" disabled={submitting || pristine} data-cy="saveButton">
                {t({ id: "saveButton" })}
              </Button>
            </DialogActions>
          </form>
        )}
      />
    );
  }, [init, onCancel, onSubmit, t]);
};

export default UpdateDeliveryKeyForm;
